<dot-loader [visibility]="userAgencies.length === 0"></dot-loader>
@for (agency of userAgencies; track agency.id) {
  @if (!canGrantAccessToCustomers(agency.id)) {
    <div class="row">
      <div class="col">
        <p class="small">
          Du måste vara byråadministratör på <strong>{{agency.name}}</strong> för att kunna se och ändra
          vilka kunder som användaren ska ha tillgång till.
        </p>
      </div>
    </div>
  }

  @if (isAgencyUser(user, agency.id) && canGrantAccessToCustomers(agency.id)) {
    <div class="row">
      <div class="col">
        <h4><a [routerLink]="['/agency', agency.id]">{{agency.nickname || agency.name}}</a> (byråanvändare)</h4>
      </div>
    </div>
      @if (agency.customers.length) {
        <div class="row">
          <div class="col">
            <button class="button primary-1" (click)="grantAccessToAllCustomers(agency)">Alla kunder</button>
            <button class="button primary-2" (click)="removeAccessAllCustomers(agency)">Inga kunder</button>
          </div>
        </div>
      }
      @if (!agency.customers.length){ 
        <p class="small">
          Byrån har inga aktiva kunder.
        </p>
      }
    
    @for (customer of agency.customers; track $index) {
      <div class="row">
        <div class="col">
          <input type="checkbox" class="checkbox" id="{{customer.id}}" [checked]="isAgencyUserAtCustomer(user, customer.id)" (change)="toggleAccess(customer, agency)">
          <label for="{{customer.id}}" class="checkbox">{{customer.nickname || customer.name}}
              @if (customer.locked){<span>(Låst)</span>}
          </label>
        </div>
      </div>
    }  

    @if (agency.inactive_customers) {
      <h4>Tidigare kunder</h4>
      @for (customer of agency.inactive_customers; track $index) {
        <div class="row">
          <div class="col">
            <input type="checkbox" class="checkbox" id="{{customer.id}}" [checked]="isAgencyUserAtCustomer(user, customer.id)" (change)="toggleAccess(customer, agency)">
            <label for="{{customer.id}}" class="checkbox">{{customer.nickname || customer.name}} (Inaktiv kund) @if (customer.locked) {<span>(Låst)</span>}</label>
          </div>
        </div>
      }
    }
  }

  @if (isAgencyAdmin(user, agency.id) && canGrantAccessToCustomers(agency.id)) {
    <div class="row">
      <div class="col">
        <h4><a [routerLink]="['/agency', agency.id]">{{agency.nickname || agency.name}}</a> (byråanvändare)</h4>
        <p class="small">Användaren har automatiskt tillgång till alla kunder som administratör.</p>
          @if (!agency.customers.length) {<p class="small">Byrån har inga kunder. </p>}
      </div>
    </div>
    @for (customer of agency.customers; track $index) {
      <div class="row">
        <div class="col">
          <input type="checkbox" id="{{customer.id}}" class="checkbox show-disabled-check" [checked]="true" disabled>
          <label for="{{customer.id}}" class="checkbox">{{customer.nickname || customer.name}}</label>
        </div>
      </div>
    }
  } 
}
  